import { Mail, Phone } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

export default function TopBar() {
    const { t } = useLanguage();

    return (
        <div className="bg-[#0A1628] text-white py-2.5 px-6" data-testid="top-bar">
            <div className="max-w-7xl mx-auto flex justify-between items-center text-sm">
                <a
                    href={`mailto:${t.topbar.email}`}
                    className="flex items-center gap-2 hover:text-blue-300 transition-colors duration-200"
                    data-testid="topbar-email"
                >
                    <Mail className="w-4 h-4" />
                    <span className="hidden sm:inline">{t.topbar.email}</span>
                </a>
                <div className="flex items-center gap-2 md:gap-4">
                    <a
                        href={`tel:${t.topbar.phone1.replace(/\s/g, "")}`}
                        className="flex items-center gap-1.5 md:gap-2 hover:text-blue-300 transition-colors duration-200"
                        data-testid="topbar-phone1"
                    >
                        <Phone className="w-3.5 h-3.5 md:w-4 md:h-4" />
                        <span className="text-[11px] sm:text-sm">{t.topbar.phone1}</span>
                    </a>
                    <span className="text-slate-500 text-xs md:text-sm">|</span>
                    <a
                        href={`tel:${t.topbar.phone2.replace(/\s/g, "")}`}
                        className="flex items-center gap-1.5 md:gap-2 hover:text-blue-300 transition-colors duration-200"
                        data-testid="topbar-phone2"
                    >
                        <Phone className="w-3.5 h-3.5 md:w-4 md:h-4" />
                        <span className="text-[11px] sm:text-sm">{t.topbar.phone2}</span>
                    </a>
                </div>
            </div>
        </div>
    );
}
